import { UtilizationPrice } from '@/api';
import {
  DailyUtilization,
  DayOfWeek,
  UtilizationRange,
  TimeWindow,
  Utilization,
} from '@/models';

export function UtilizationMapper(
  utilizationPrices: UtilizationPrice[]
): Utilization[] {
  const utilizationMap = new Map<number, Utilization>();

  utilizationPrices.forEach((price) => {
    if (!price.priceWindowId || price.dayOfTheWeek === undefined) return;

    let utilization = utilizationMap.get(price.priceWindowId);

    if (!utilization) {
      utilization = new Utilization();
      utilization.priceWindowId = price.priceWindowId;
      utilizationMap.set(price.priceWindowId, utilization);
    }

    // Ensure DailyUtilization for each day of the week, even if no data
    Object.values(DayOfWeek).forEach((day) => {
      if (typeof day === 'number') {
        let dailyUtilization = utilization!.dailyUtilizations.find(
          (du) => du.dayOfWeek === day
        );

        if (!dailyUtilization) {
          dailyUtilization = new DailyUtilization(day);
          utilization!.dailyUtilizations.push(dailyUtilization);
        }

        // If this day's utilization matches the price data, add TimeWindow
        if (day === price.dayOfTheWeek) {
          const newTimeWindow = new TimeWindow();
          newTimeWindow.startTime = price.startTime
            ? new Date(price.startTime)
            : undefined;
          newTimeWindow.endTime = price.endTime
            ? new Date(price.endTime)
            : undefined;
          newTimeWindow.timeWindowDescription =
            price.timeWindowDescription || '';

          // Create the UtilizationRange and add to TimeWindow
          if (
            price.low !== null ||
            price.high !== null ||
            price.priceAmount !== null ||
            price.pricePercentage !== null
          ) {
            const newRange = new UtilizationRange();
            newRange.low = price.low ?? 0;
            newRange.high = price.high ?? 100;
            newRange.pricePercentage = price.pricePercentage ?? 100;
            newRange.priceAmount = price.priceAmount ?? 0;
            newRange.usePercent = price.usePercent ?? false;

            newTimeWindow.utilizationRanges = [newRange];
          } else {
            newTimeWindow.utilizationRanges = undefined; // Support null ranges
          }

          dailyUtilization.timeWindows = dailyUtilization.timeWindows || [];
          dailyUtilization.timeWindows.push(newTimeWindow);
        }
      }
    });
  });

  return Array.from(utilizationMap.values());
}
